if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.variantDescription = this.querySelector('.product-detail-hero__variant-description');
        this.addType = this.getAttribute('add-type') ? this.getAttribute('add-type') : 'dynamic';
        this.removeButton = this.querySelector('.quick-remove');
        this.querySelectorAll('input[type=radio]').forEach((radio) => {
          radio.addEventListener('change', this.onChangeVariantHandler.bind(this));
        });
        this.thumbSlides = document.querySelectorAll('.product-media__carousel .swiper-slide[data-variant-id]');

        [...this.thumbSlides].forEach((slide) => {
          slide.addEventListener('click', this.onSlideClickHandler.bind(this));
        });

        const defaultVariantSelection = this.form.querySelector('input[name="id"]:checked');
        if (defaultVariantSelection) {
          const variantId = defaultVariantSelection.value;
          const descHtml = document.getElementById(`variant-desc-${variantId}`).innerHTML;
          this.variantDescription.innerHTML = descHtml;
        }

        if (this.hasAttribute('no-flyout-cart')) {
          this.addType = 'static';
        }

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.removeButton) {
          this.removeButton.addEventListener('click', this.onRemoveHandler.bind(this));
        }
      }

      onRemoveHandler(evt) {
        evt.preventDefault();
        const button = evt.target.parentNode.querySelector('.quick-add__submit');
        const lineItemIndex = parseInt(evt.target.getAttribute('data-line-item-index')) + 1;
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        const label = button.getAttribute('data-label');
        cartItems.updateQuantity(lineItemIndex, 0);
        evt.target.classList.remove('quick-remove--show');
        button.classList.remove('button--secondary');
        button.classList.add('button--primary');
        button.disabled = false;
        if (label) {
          button.querySelector(':scope > span').innerHTML = button.getAttribute('data-label');
        } else {
          button.querySelector(':scope > span').innerHTML = 'Add To Cart';
        }
      }

      onChangeVariantHandler(evt) {
        const input = evt.target;
        const variantId = input.value;
        const descHtml = document.getElementById(`variant-desc-${variantId}`).innerHTML;

        this.variantDescription.innerHTML = descHtml;
        this.submitButton.querySelector(':scope > span:first-of-type').innerHTML =
          `Add To Cart — ${input.getAttribute('data-price')}`;

        const swiperContainer = document.querySelector('.product-media__slider .swiper');
        if (swiperContainer && swiperContainer.swiper) {
          const targetSlide = swiperContainer.querySelector(`.swiper-slide[data-variant-id="${variantId}"]`);
          if (targetSlide) {
            const index = Array.from(targetSlide.parentNode.children).indexOf(targetSlide);
            swiperContainer.swiper.slideTo(index);
          }
        }
      }

      onSlideClickHandler(evt) {
        const slide = evt.currentTarget;
        const variantId = slide.getAttribute('data-variant-id');
        const variantSelector = this.form.querySelector(`input[name="id"][value="${variantId}"]`);

        if (variantSelector) {
          variantSelector.checked = true;
          variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response, this.addType);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response, this.addType);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            const cart = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
            const cartItems = cart.querySelectorAll('.cart-item');
            const id = this.submitButton.id.split('-submit')[0];
            const removeButton = this.submitButton.parentNode.querySelector('.quick-remove');
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if (this.addType == 'static') {
              const checkoutLink = document.querySelector('.modal-upsell__checkout-link');
              this.submitButton.classList.remove('button--primary');
              this.submitButton.classList.add('button--secondary');
              this.submitButton.disabled = true;
              this.submitButton.querySelector(':scope > span').innerHTML = 'Added To Cart';
              removeButton.classList.add('quick-remove--show');
              cartItems.forEach((item) => {
                if (id == item.getAttribute('data-id')) {
                  removeButton.setAttribute('data-line-item-index', item.getAttribute('data-index'));
                }
              });
              if (checkoutLink) {
                checkoutLink.classList.add('modal-upsell__checkout-link--is-final');
                checkoutLink.querySelector('span').innerHTML = 'Go To Checkout';
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
